import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'
import { tideCashBackAmount } from './business-banking-strings'

const defaultStrings = {
  cashback: `${tideCashBackAmount} cashback`,
  claimOffer: 'Claim offer',
  collect: 'Collect',
  collectDescription:
    'When we receive your post, we email you and keep it secure for 30 days until you can collect it.',
  collectSummary: 'Mail Handling\nDrop off/Pick up point',
  crunchServiceCTA: 'Claim offer',
  crunchServiceDescription:
    'Get fully featured bookkeeping software for your business completely free. <strong>Free forever.</strong> No hidden charges. Add a real accountant at any time.',
  crunchServiceOffer: 'FREE',
  crunchServiceTitle: 'Crunch Free Accounting',
  directorsServiceAddress: 'Full Privacy Service',
  directorsServiceAddressDescription:
    'Protect the privacy of your home address by using our London address as directors service address.',
  forward: 'Forward',
  forwardDescription:
    'We forward all your post to your private address within one business day of receiving it.',
  forwardSummary: 'Mail Handling\nand Forwarding',
  freeConsultation: 'FREE Consultation',
  freePostageCredit: 'Free postage credit',
  introductionToAnAccountant: 'Introduction to an Accountant',
  introductionToAnAccountantDescription:
    'Accountancy servicing for startups, freelancers <br/> and small businesses.',
  meetings: 'Meetings',
  meetingsDescription:
    '<span class="d-sm-inline d-block">Ideal for events, meetings</span> & training sessions.',
  meetingsSummary: 'Meeting Room Rental',
  noHandlingFees: 'No handling fees',
  noPostageFees: 'Free postage credit',
  phone: 'Phone',
  phoneDescription:
    '<span class="d-sm-inline d-block">Transfer to UK/EU/US Land-line,</span> as well as UK Mobiles.',
  phoneSummary: 'London 020 Number',
  primeLondonNumber: 'Prime London number',
  scanLite: 'Virtual Office + HaiRo™',
  scanLiteDescription:
    '<span class="d-sm-inline d-block">We scan and email all your post to</span> you within one business day of receiving it.',
  scanLiteSummary: 'Mail Handling\nScanned and Emailed',
  scanPro: 'Mail Forwarding',
  scanProDescription:
    'We scan, email, and forward the hard copies to you by post within one business day.',
  scanProSummary:
    'As well as being scanned, your mail will be forwarded within one business day to an address of your choice.',
  tideBusinessBanking: 'Tide Business Banking',
  tideBusinessBankingDescription: `Get a free bank account with <strong>${tideCashBackAmount} cashback</strong>.*<br/>T&Cs apply.`,
  virtualOfficePhone: 'Virtual Office Phone',
  virtualOfficePhoneDescription:
    'Get a virtual landline and divert your business calls to your mobile and stay connected wherever you are.',
  workFromAnywhere: 'Work from anywhere',
}
export const planSummaryStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
